import React from 'react'
import { useHistory } from 'react-router-dom'
import { State } from '../store'
import { useSelector } from 'react-redux'
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { ListItemLocation } from './ListItemLocation'
import { Icon } from './Icon'

export const AdminSidebarNav: React.FC = () => {
  const history = useHistory()
  const defaultSelection = useSelector((state: State) => state.ui.defaultSelection)
  const currentPath = history.location.pathname

  const handleNavClick = (baseRoute: string) => {
    const adminSelection = defaultSelection['admin']
    const savedRoute = adminSelection?.[baseRoute]
    history.push(savedRoute || baseRoute)
  }

  return (
    <List
      sx={{
        position: 'static',
        '& .MuiListItemIcon-root': {
          color: 'grayDark.main',
        },
        '& .MuiListItemText-primary': {
          color: 'grayDarkest.main',
        },
        '& .MuiListItemButton-root:hover .MuiListItemText-primary': {
          color: 'black.main',
        },
        '& .Mui-selected, & .Mui-selected:hover': {
          backgroundColor: 'primaryLighter.main',
          '& .MuiListItemIcon-root': {
            color: 'grayDarker.main',
          },
          '& .MuiListItemText-primary': {
            color: 'black.main',
            fontWeight: 500,
          },
        },
      }}
    >
      <ListItemLocation dense title="Return to App" icon="person-to-portal" to="/devices" />

      <ListItemButton
        dense
        selected={currentPath.includes('/admin/users')}
        onClick={() => handleNavClick('/admin/users')}
      >
        <ListItemIcon>
          <Icon name="users" size="md" />
        </ListItemIcon>
        <ListItemText primary="Users" />
      </ListItemButton>

      <ListItemButton
        dense
        selected={currentPath.includes('/admin/devices')}
        onClick={() => handleNavClick('/admin/devices')}
      >
        <ListItemIcon>
          <Icon name="router" size="md" />
        </ListItemIcon>
        <ListItemText primary="Devices" />
      </ListItemButton>

      <ListItemButton
        dense
        selected={currentPath.includes('/admin/admins')}
        onClick={() => handleNavClick('/admin/admins')}
      >
        <ListItemIcon>
          <Icon name="shield" size="md" />
        </ListItemIcon>
        <ListItemText primary="Admins" />
      </ListItemButton>

      <ListItemButton
        dense
        selected={currentPath.includes('/admin/partners')}
        onClick={() => handleNavClick('/admin/partners')}
      >
        <ListItemIcon>
          <Icon name="handshake" size="md" />
        </ListItemIcon>
        <ListItemText primary="Partners" />
      </ListItemButton>

      <ListItemButton
        dense
        selected={currentPath.includes('/admin/enterprise-licenses')}
        onClick={() => handleNavClick('/admin/enterprise-licenses')}
      >
        <ListItemIcon>
          <Icon name="building" size="md" />
        </ListItemIcon>
        <ListItemText primary="Enterprise" />
      </ListItemButton>

      <ListItemButton
        dense
        selected={currentPath.includes('/admin/notices')}
        onClick={() => handleNavClick('/admin/notices')}
      >
        <ListItemIcon>
          <Icon name="bullhorn" size="md" />
        </ListItemIcon>
        <ListItemText primary="Notices" />
      </ListItemButton>
    </List>
  )
}
